import {
  Box,
  Button,
  IconButton,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
} from "@mui/material";
import React from "react";
import InputControl from "../../../shared/components/InputControl";
import { Add, Remove } from "@mui/icons-material";
import { useImmer } from "use-immer";

const tableCellStyle = {
  borderBottom: "1px solid #E6E6E6",
};
export const PartialRefundProductTable = ({
  state,
  refundState,
  addAll,
  inrementOrDecrementQty,
  onChange,
  onChangeRefundQty,
  checkIfRefundable,
  validator,
}) => {
  const totalPrice = refundState.refund_items.reduce(
    (sum, item) => sum + (item.group_total / item.quantity) * item.refundQty,
    0,
  );
  const refundAmount =
    Number(totalPrice) - Number(refundState.deduction_amount);
  return (
    <Paper sx={{ boxShadow: "none" }}>
      <TableContainer>
        <Table sx={{ minWidth: 700 }} aria-label="spanning table">
          <TableHead>
            <TableRow>
              <TableCell align="left">Item</TableCell>
              <TableCell align="left">Quantity</TableCell>
              <TableCell align="left">Sale Price</TableCell>
              <TableCell align="left">Total Price</TableCell>
              <TableCell align="right">
                <Button
                  size="small"
                  sx={{ height: "32px" }}
                  variant="outlined"
                  onClick={addAll}
                >
                  Add All
                </Button>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {refundState.refund_items?.map((item, index) => {
              return (
                <>
                  <TableRow>
                    <TableCell sx={tableCellStyle} key={1}>
                      {item?.product_name} {item.has_tax ? "*" : ""}{" "}
                      {state.data?.customer?.id &&
                      !item.loyalty_points_accumulated
                        ? "^"
                        : ""}
                      <Typography variant="body2" color="#636363" mt="4px">
                        {item?.child_products?.length > 0
                          ? item.child_products.map((data, i) => (
                              <div style={{ marginTop: "2px" }}>
                                {data.product_name}
                                {data.has_tax ? "*" : ""}
                                {data?.child_products?.length > 0 &&
                                  data?.child_products?.map((item) => (
                                    <div
                                      style={{
                                        marginLeft: "8px",
                                        marginTop: "2px",
                                      }}
                                    >
                                      {item?.product_name}
                                      {item.has_tax ? "*" : ""}
                                    </div>
                                  ))}
                              </div>
                            ))
                          : ""}
                      </Typography>
                    </TableCell>
                    <TableCell sx={tableCellStyle} key={2}>
                      {item?.quantity}
                      <Typography variant="body2" color="#636363" mt="4px">
                        {item?.child_products?.length > 0
                          ? item?.child_products?.map((data, i) => (
                              <div style={{ marginTop: "2px" }}>
                                {data?.quantity}
                                {data?.child_products?.length > 0
                                  ? data.child_products.map((ch, i) => (
                                      <div style={{ marginTop: "2px" }}>
                                        {ch.quantity}
                                      </div>
                                    ))
                                  : ""}
                              </div>
                            ))
                          : ""}
                      </Typography>
                    </TableCell>

                    <TableCell sx={tableCellStyle} key={4}>
                      ${item?.price?.toFixed(2)}
                      <Typography variant="body2" color="#636363" mt="4px">
                        {item?.child_products?.length > 0
                          ? item.child_products.map((data, i) => (
                              <div style={{ marginTop: "2px" }}>
                                ${data?.price?.toFixed(2)}
                                {data?.child_products?.length > 0
                                  ? data.child_products.map((ch, i) => (
                                      <div style={{ marginTop: "2px" }}>
                                        ${ch?.price?.toFixed(2)}
                                      </div>
                                    ))
                                  : ""}
                              </div>
                            ))
                          : ""}
                      </Typography>
                    </TableCell>
                    <TableCell sx={tableCellStyle} align="left" key={5}>
                      ${item?.group_total?.toFixed(2)}
                    </TableCell>
                    <TableCell align="right" key={6} sx={tableCellStyle}>
                      <Stack gap={1}>
                        <Stack
                          direction={"row"}
                          display={"flex"}
                          alignItems={"center"}
                          justifyContent={"end"}
                          gap={2}
                        >
                          <IconButton
                            sx={{
                              border: "1px solid #e0e0e0",
                              width: 36,
                              height: 36,
                              borderRadius: "50%",
                            }}
                            disabled={
                              item.refundQty < 1 || !checkIfRefundable(item.id)
                            }
                            onClick={() =>
                              inrementOrDecrementQty("decrement", index)
                            }
                          >
                            <Remove />
                          </IconButton>
                          <InputControl
                            width={68}
                            size="small"
                            value={item.refundQty}
                            disabled={!checkIfRefundable(item.id)}
                            onChange={(e) => onChangeRefundQty(e, index)}
                          />

                          <IconButton
                            sx={{
                              border: "1px solid #e0e0e0",
                              width: 36,
                              height: 36,
                              borderRadius: "50%",
                            }}
                            disabled={
                              item.refundQty > item.quantity - 1 ||
                              !checkIfRefundable(item.id)
                            }
                            onClick={() =>
                              inrementOrDecrementQty("increment", index)
                            }
                          >
                            <Add />
                          </IconButton>
                        </Stack>
                        <Box color={"#C60808"}>
                          {validator.current.message(
                            ` quantity-${index}`,
                            { refundQty: item.refundQty, qty: item.quantity },
                            "customqty",
                          )}
                        </Box>
                      </Stack>
                    </TableCell>
                  </TableRow>
                </>
              );
            })}

            <TableRow>
              <TableCell colSpan={3}></TableCell>
              <TableCell
                sx={{
                  borderBottom: "1px solid #E6E6E6",
                  borderLeft: "1px solid #E6E6E6",
                }}
              >
                Total
              </TableCell>
              <TableCell
                sx={{
                  borderBottom: "1px solid #E6E6E6",
                }}
                align="right"
              >
                ${totalPrice.toFixed(2)}
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell colSpan={3}></TableCell>
              <TableCell
                sx={{
                  borderBottom: "1px solid #E6E6E6",
                  borderLeft: "1px solid #E6E6E6",
                  fontWeight: "400",
                }}
              >
                <Stack direction={"row"} gap={1} alignItems={"center"}>
                  Deduction
                  <Tooltip title="Entered amount will be deducted from the total refund.">
                    <img
                      style={{
                        height: "18px",
                      }}
                      alt="details"
                      src="/icons/ic_info.svg"
                    />
                  </Tooltip>
                </Stack>
              </TableCell>
              <TableCell
                sx={{
                  borderBottom: "1px solid #E6E6E6",
                  fontWeight: "400",
                }}
                align="right"
              >
                <InputControl
                  name="deduction_amount"
                  value={refundState.deduction_amount}
                  onChange={onChange}
                  width={68}
                  size="small"
                  placeholder="$0.00"
                />

                <Box color={"#C60808"} marginTop={1}>
                  {validator.current.message(
                    "amount",
                    {
                      deduction_amount: refundState.deduction_amount,
                      total_amount: totalPrice,
                    },
                    "deduction",
                  )}
                </Box>
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell colSpan={3}></TableCell>
              <TableCell
                sx={{
                  borderBottom: "1px solid #E6E6E6",
                  borderLeft: "1px solid #E6E6E6",
                  color: "#A04D3D",
                  fontWeight: 700,
                }}
              >
                Refund Amount
              </TableCell>
              <TableCell
                sx={{
                  borderBottom: "1px solid #E6E6E6",
                  color: "#A04D3D",
                  fontWeight: 700,
                }}
                align="right"
              >
                ${refundAmount.toFixed(2) || 0}
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
};
